import {TDBaseShape} from '@modules/whiteboard'

export interface FrameShape extends TDBaseShape {
  type: 'frame'
  size: number[]
  title?: string

  objectFit?: 'contain' | 'cover'
  backgroundImage?: { exId?: string}

}

export * from './FrameUtil'
export * from './FrameShapeComponent'


// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/frame/index.ts